import React, { useState } from 'react';
import { Box, FormControl, Select, MenuItem, Typography, Button } from '@mui/material';
import SectionHeader from './SectionHeader';
import DocumentUploadBox from './DocumentUploadBox';
export default function DocumentUploadSection({ documents, onAddDocument }) {
    const [documentType, setDocumentType] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [additionalDocuments, setAdditionalDocuments] = useState([]);

    const handleDocumentTypeChange = (e) => {
        setDocumentType(e.target.value);
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleUpload = () => {
        if (documentType && selectedFile) {
            onAddDocument({
                type: documentType,
                file: selectedFile,
                uploadedAt: new Date().toISOString()
            });
            setDocumentType('');
            setSelectedFile(null);
        }
    };

    const handleAddDocumentBox = () => {
        setAdditionalDocuments([...additionalDocuments, { type: '', file: null }]);
    };

    const handleAdditionalDocumentChange = (index, field, value) => {
        const updatedDocuments = [...additionalDocuments];
        updatedDocuments[index] = {
            ...updatedDocuments[index],
            [field]: value
        };
        setAdditionalDocuments(updatedDocuments);
    };

    return (
        <Box>
            <SectionHeader 
                title="Upload Documents (Photo ID, Driving License ID, Address Proof)" 
                light={true} 
            />

            <Box sx={{ p: 2 }}>
                <Box sx={{ mb: 2 }}>
                    <Box>
                        {/* Document Upload Boxes Container */}
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'flex-start' }}>
                            {/* Document Upload Box 1 */}
                            <DocumentUploadBox 
                                documentType={documentType}
                                onDocumentTypeChange={handleDocumentTypeChange}
                                onFileChange={handleFileChange}
                                selectedFile={selectedFile}
                                onUpload={handleUpload}
                            />

                            {/* Additional document boxes */}
                            {additionalDocuments.map((doc, index) => (
                                <DocumentUploadBox 
                                    key={index}
                                    documentType={doc.type}
                                    onDocumentTypeChange={(e) => handleAdditionalDocumentChange(index, 'type', e.target.value)}
                                    onFileChange={(e) => handleAdditionalDocumentChange(index, 'file', e.target.files[0])}
                                    selectedFile={doc.file}
                                    onUpload={() => {
                                        if (doc.type && doc.file) {
                                            onAddDocument({
                                                type: doc.type,
                                                file: doc.file,
                                                uploadedAt: new Date().toISOString()
                                            });
                                            // Remove this document box after upload
                                            const newDocs = [...additionalDocuments];
                                            newDocs.splice(index, 1);
                                            setAdditionalDocuments(newDocs);
                                        }
                                    }}
                                />
                            ))}

                            {/* Plus Button to Add More Document Upload Boxes */}
                            <Box
                                sx={{
                                    width: 220,
                                    height: 290,
                                    border: '2px dashed #ccc',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    '&:hover': { borderColor: '#aaa' }
                                }}
                                onClick={handleAddDocumentBox}
                            >
                                <Typography variant="h3" sx={{ color: '#999' }}>+</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}